var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("search-bar", {
        attrs: {
          prev_filter_string: _vm.prev_filter_string,
          title: _vm.title,
          bookmark: _vm.bookmark
        },
        on: { search_event: _vm.searchEvent, refresh_event: _vm.requestResults }
      }),
      _vm._v(" "),
      _vm.filters.toggle_active
        ? _c(
            "div",
            { staticClass: "d-flex  justify-content-start align-items-center" },
            [
              _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      _vm.filters.show_options = !_vm.filters.show_options
                    }
                  }
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("filter_list")
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.filters.show_options
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center"
                    },
                    [
                      _vm._l(_vm.columns, function(key) {
                        return [
                          _vm.getFilterOptions(key).type == "date"
                            ? _c("div", { staticClass: "p-3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-uppercase mb-3",
                                    attrs: {
                                      "data-component-key": key,
                                      "data-component-reference_field": _vm.getFilterOptions(
                                        key
                                      ).reference_field,
                                      "data-component-type": _vm.getFilterOptions(
                                        key
                                      ).type
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.filterOptionSelect(key)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(key) + "\n                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.types[key].active == true
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-content-between align-items-center"
                                      },
                                      [
                                        _c("div", { staticClass: "md-form" }, [
                                          _c("input", {
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "date",
                                              id: "date_start--" + key
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass: " active",
                                              attrs: {
                                                for: "date_start--" + key
                                              }
                                            },
                                            [_vm._v("from")]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "md-form" }, [
                                          _c("input", {
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "date",
                                              id: "date_end--" + key
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass: " active",
                                              attrs: { for: "date_end--" + key }
                                            },
                                            [_vm._v("to")]
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { attrs: { id: "table--search" } }, [
        _vm.filteredItems.length
          ? _c(
              "table",
              {
                staticClass: "table table--search-table",
                staticStyle: {
                  "font-variant-numeric": "lining-nums tabular-nums"
                }
              },
              [
                _c("thead", {}, [
                  _c(
                    "tr",
                    { staticClass: "table-primary d-none d-md-table-row" },
                    [
                      _vm._l(_vm.columns, function(key) {
                        return [
                          _vm.canFilterField(key)
                            ? _c(
                                "th",
                                {
                                  class: _vm.setCellType(key),
                                  attrs: { key_ref: key },
                                  on: {
                                    click: function($event) {
                                      _vm.sortBy(key)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex  align-items-center",
                                      class: _vm.setCellType(key, true)
                                    },
                                    [
                                      _c("div", {}, [
                                        key == "category"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-start align-items-center"
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "d-md-none d-flex material-icons mr-2"
                                                  },
                                                  [_vm._v("filter_list")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "d-none d-md-flex"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("capitalize")(
                                                          key
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : key == "id"
                                            ? _c("div", [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm._f("lowercase")(key)
                                                    ) +
                                                    "\n                                "
                                                )
                                              ])
                                            : _c(
                                                "div",
                                                {
                                                  staticClass: "text-capitalize"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        _vm._f("capitalize")(
                                                          key
                                                        )
                                                      ) +
                                                      "\n                                "
                                                  )
                                                ]
                                              )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [
                                          _vm.sortOrders[key] > 0
                                            ? [_vm._v("arrow_drop_up")]
                                            : _vm.sortOrders[key] < 0
                                              ? [_vm._v("arrow_drop_down")]
                                              : [_vm._v("unfold_more")]
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _c("th", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm._f("capitalize")(key)) +
                                    "\n                    "
                                )
                              ])
                        ]
                      }),
                      _vm._v(" "),
                      _c("th")
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.filteredItems, function(item) {
                    return _c(
                      "tr",
                      {
                        staticClass:
                          "card z-depth-1 mb-2 d-md-table-row bg-level-4"
                      },
                      [
                        _vm._l(_vm.columns, function(key) {
                          return _c(
                            "td",
                            {
                              staticClass:
                                "py-0 py-md-1 d-flex d-md-table-cell justify-content-between align-items-center",
                              class: [
                                _vm.setCellType(key),
                                {
                                  "fs-md-inherit":
                                    _vm.type_in_array(key, [
                                      "slug",
                                      "string",
                                      "title",
                                      "json",
                                      "status"
                                    ]) === true,

                                  "py-md-0 p-md-2":
                                    _vm.type_in_array(key, [
                                      "icon",
                                      "slug",
                                      "category",
                                      "string",
                                      "title",
                                      "json",
                                      "status",
                                      "date",
                                      "date_time",
                                      "datetime",
                                      "time"
                                    ]) === true,

                                  "old--d-inline-flex":
                                    _vm.type_in_array(key, [
                                      "id",
                                      "money",
                                      "category",
                                      "icon",
                                      "date",
                                      "date_time",
                                      "datetime",
                                      "time",
                                      "status"
                                    ]) === true,

                                  "text-right":
                                    _vm.type_in_array(key, ["money"]) === true,

                                  "text-md-nowrap ":
                                    _vm.type_in_array(key, [
                                      "slug",
                                      "title"
                                    ]) === true,

                                  "fs-3":
                                    _vm.type_in_array(key, ["title"]) === true
                                }
                              ],
                              attrs: { "data-key": key }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "d-block d-md-none text-muted",
                                  class: {
                                    "text-lowercase":
                                      _vm.type_in_array(key, ["id"]) === true,
                                    "text-capitalize":
                                      _vm.type_in_array(key, ["id"]) !== true
                                  }
                                },
                                [_vm._v(_vm._s(key) + ":")]
                              ),
                              _vm._v(" "),
                              _vm.types[key].type == "icon"
                                ? [
                                    _vm.isMaterialIcon(item[key]) === true
                                      ? _c(
                                          "i",
                                          {
                                            staticClass: "material-icons",
                                            class:
                                              "table--" + _vm.types[key].type,
                                            attrs: {
                                              "data-element-type":
                                                _vm.types[key].type
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.readIconContent(item[key])
                                              )
                                            )
                                          ]
                                        )
                                      : _c("i", {
                                          staticClass: "fa icon",
                                          class: [
                                            _vm.readIconClass(item[key], item),
                                            "table--" + _vm.types[key].type
                                          ],
                                          attrs: {
                                            "data-element-type":
                                              _vm.types[key].type
                                          }
                                        })
                                  ]
                                : _vm.types[key].type == "category"
                                  ? [
                                      _c(
                                        "code",
                                        {
                                          staticClass: "text-nowrap",
                                          class:
                                            "table--" + _vm.types[key].type,
                                          attrs: {
                                            "data-element-type": "category",
                                            "data-value": item[key]
                                          }
                                        },
                                        [_vm._v(_vm._s(item[key]))]
                                      )
                                    ]
                                  : _vm.types[key].type == "date"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "text-nowrap",
                                          class:
                                            "table--" + _vm.types[key].type,
                                          attrs: {
                                            "data-element-type": "date",
                                            "data-value": item[key]
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(item[key]) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    : _vm.types[key].type == "date_time"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "text-nowrap",
                                            class:
                                              "table--" + _vm.types[key].type,
                                            attrs: {
                                              "data-element-type": "date_time",
                                              "data-raw": item[key]
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  _vm.getDate(
                                                    item[key],
                                                    _vm.types[key].type
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      : _vm.types[key].type == "number"
                                        ? [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(item[key]) +
                                                "\n                    "
                                            )
                                          ]
                                        : _vm.types[key].type == "slug"
                                          ? [
                                              _c(
                                                "code",
                                                {
                                                  staticClass: "text-nowrap",
                                                  class:
                                                    "table--" +
                                                    _vm.types[key].type,
                                                  attrs: {
                                                    "data-element-type": "slug",
                                                    "data-value": item[key]
                                                  }
                                                },
                                                [_vm._v(_vm._s(item[key]))]
                                              )
                                            ]
                                          : _vm.types[key].type == "json"
                                            ? [
                                                _c("BaseJsonView", {
                                                  staticClass: "px-2 bg-dark",
                                                  class:
                                                    "table--" +
                                                    _vm.types[key].type,
                                                  attrs: {
                                                    json_counter: 0,
                                                    json: _vm.getJson(item[key])
                                                  }
                                                })
                                              ]
                                            : _vm.types[key].type == "money"
                                              ? [
                                                  item[key] != ""
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "money currency-sign text-right text-nowrap",
                                                          class:
                                                            "table--" +
                                                            _vm.types[key].type,
                                                          attrs: {
                                                            "data-element-type":
                                                              _vm.types[key]
                                                                .type,
                                                            "data-value":
                                                              item[key]
                                                          }
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(item[key])
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    : _c(
                                                        "span",
                                                        {
                                                          class:
                                                            "table--" +
                                                            _vm.types[key].type
                                                        },
                                                        [_vm._v(" - ")]
                                                      )
                                                ]
                                              : _vm.types[key].type == "status"
                                                ? [
                                                    _vm.status_url === null
                                                      ? _c(
                                                          "code",
                                                          {
                                                            staticClass:
                                                              "text-nowrap",
                                                            class: [
                                                              {
                                                                disabled:
                                                                  item[key] ===
                                                                  "inactive"
                                                              },
                                                              "table--" +
                                                                _vm.types[key]
                                                                  .type
                                                            ],
                                                            attrs: {
                                                              "data-element-type":
                                                                "status",
                                                              "data-value":
                                                                item[key]
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item[key]
                                                              ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _c(
                                                          "base-switch-events",
                                                          {
                                                            staticClass:
                                                              "flex align-items-end align-items-md-start",
                                                            attrs: {
                                                              tabindex: 0,
                                                              row: false,
                                                              status: item[key],
                                                              field: "status",
                                                              identifier:
                                                                "set_status",
                                                              switch_off: "off",
                                                              switch_on: "on",
                                                              title:
                                                                "Quick set status"
                                                            },
                                                            on: {
                                                              status_change: function(
                                                                value
                                                              ) {
                                                                _vm.updateStatus(
                                                                  item,
                                                                  key,
                                                                  value
                                                                )
                                                              }
                                                            }
                                                          }
                                                        )
                                                  ]
                                                : _vm.types[key].type == "id"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "d-flex  justify-content-start align-items-center",
                                                        class:
                                                          "table--" +
                                                          _vm.types[key].type,
                                                        attrs: {
                                                          "data-element-type":
                                                            "id"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            " +
                                                            _vm._s(item[key]) +
                                                            "\n                        "
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "data-element-type":
                                                            "string"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            " +
                                                            _vm._s(item[key]) +
                                                            "\n                        "
                                                        )
                                                      ]
                                                    )
                            ],
                            2
                          )
                        }),
                        _vm._v(" "),
                        _c("td", {}, [
                          _c(
                            "div",
                            {
                              staticClass:
                                " d-flex justify-content-center justify-content-md-center align-items-center"
                            },
                            [
                              _vm._l(["read"], function(crud) {
                                return _vm.crud_route_exists(
                                  "read",
                                  "update",
                                  "delete"
                                )
                                  ? [
                                      _vm.hasRoutePattern(crud, item)
                                        ? _c("BaseIconButton", {
                                            staticClass: "btn-primary",
                                            attrs: {
                                              float: true,
                                              route: _vm.crud_route(crud, item),
                                              icon: {
                                                content: _vm.crud_route_icon(
                                                  crud
                                                )
                                              },
                                              tag_name: "a"
                                            }
                                          })
                                        : _c("BaseIconButton", {
                                            staticClass: "btn-primary",
                                            attrs: {
                                              float: true,
                                              icon: {
                                                content: _vm.crud_route_icon(
                                                  crud
                                                )
                                              },
                                              tag_name: "div"
                                            },
                                            on: {
                                              click_event: function($event) {
                                                _vm.crud_route(crud, item)
                                              }
                                            }
                                          })
                                    ]
                                  : _vm._e()
                              })
                            ],
                            2
                          )
                        ])
                      ],
                      2
                    )
                  })
                )
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-229262c3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-229262c3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/tables/tableSearch.vue
// module id = 342
// module chunks = 0